import { render, staticRenderFns } from "./StudentDocs.vue?vue&type=template&id=214c72c6&"
import script from "./StudentDocs.vue?vue&type=script&lang=js&"
export * from "./StudentDocs.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports